module.exports = __webpack_public_path__ + "static/img/logistics-h5.cb2fcc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logistics-h5.png
// module id = xMXe
// module chunks = 34